import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function TrustBar() {
  const items = ['Free In-Home Quotes', 'Custom Measured', 'Frameless & Euro Options', '18 Glass Textures', 'Hardware Finish Options', 'Professional Installation', 'Lifetime Installation Guarantee', 'Howell, Ann Arbor & Novi'];
  return <div className="bg-navy-900 py-6 border-y border-navy-800" data-id="element-1521" data-mp="3dx59qtx5a7ky">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1522" data-mp="2h8p8i0koa9s0">
        <div className="flex flex-wrap justify-center gap-3 md:gap-6 lg:gap-8" data-id="element-1523" data-mp="2l9995e4gfviw">
          {items.map((item, i) => <div key={i} className="flex items-center gap-2 anim-fade-up" style={{
          animationDelay: `${i * 0.05}s`
        }} data-id="element-1524" data-mp="2q7ubbj39op9z" data-mpi={i}>
              <CheckCircle2 className="w-4 h-4 text-primary" data-id="element-1525" data-mp="1xkgh3sqye7tk" />
              <span className="text-sm md:text-base font-medium text-white whitespace-nowrap" data-id="element-1526" data-mp="1xhu8rqw8noaa">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}